import React, { useState, useEffect, useCallback } from 'react';
import { Table, Message } from '@b-design/fusion';
import { getColumns, renderActionItem } from './const';
import $i18n from '@/i18n';
// import Space from '@/components/Space';
import Requests from '@/services/request';
import PaginationComponent from '@/components/PaginationComponent';
import './index.less';
import { history } from 'ice';
import { queryStringify, getQueryStringArgs } from '@/utils/url-parse';
import store from '@/store';
import { Divider } from '@alifd/next';
import Confirm from '@/components/Confirm';
// import Spining from '@/components/Spining'

interface MyRequest {
  contentHeight: number;
}

const MyRequest: React.FC<MyRequest> = ({ contentHeight }) => {
  // const [pageSize, setPageSize] = React.useState(10);

  const [userState] = store.useModel('user');
  const { spaceId } = getQueryStringArgs();
  const [column, setColumns] = useState<any[]>(getColumns(spaceId));
  const [dataSource, setDataSource] = useState({ list: [], total: 0 });
  const { accountId } = userState.currentUser;
  const [loading, setLoading] = useState(false);

  // 分页参数
  const [paginationValue, setPaginationValue] = useState<
    Record<'currentPage' | 'pageSize', number>
  >({
    currentPage: 1,
    pageSize: 10,
  });
  // 初始数据
  const queryMyRequest = useCallback(
    async (params = { currentPage: 1, pageSize: 10, createUid: accountId, sourceSpaceId: spaceId }) => {
      if (!spaceId) {
        return;
      }
      setLoading(true);
      const data = await Requests.get('/rest/intercnn/approve/query', { ...params });
      if (data) {
        const { list = [], total } = data;
        setDataSource({ list, total });
        setLoading(false);
      }
    },
    [spaceId],
  );
  // 撤回按钮

  const handleOk = useCallback(
    async (record) => {
      const data = await Requests.post('/rest/intercnn/approve/process', {
        approveId: record.approveId,
        approveAction: 'WITHDRAW',
        approveOpinion: 'WITHDRAW',
      });
      if (data) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.invitation.spaces.message.Success',
            dm: '操作成功!',
          }),
        });
        await queryMyRequest({ createUid: accountId, ...paginationValue, sourceSpaceId: spaceId });
      }
    },
    [queryMyRequest, paginationValue],
  );

  const changeRouter = (record) => {
    history?.push(
      `/approvals/detail?${queryStringify({
        spaceId,
        approveId: record.approveId,
        defaultActiveKey: 'MyRequest',
      })}`,
    );
  };

  useEffect(() => {

    const actionRender = {
      title: $i18n.get({ id: 'aopf.pages.member.columnsAction', dm: '操作' }),
      dataIndex: 'action',
      width: 190,
      // lock: true,
      cell: (value, index, record) => (
        <div style={{ color: 'var(--superapp-primary-1)', display: 'flex' }}>
          <div onClick={() => changeRouter(record)}>
            {renderActionItem({
              icon: 'view--outline',
              content: $i18n.get({
                id: 'aopf.pages.approvals.columnsActionView',
                dm: '查看',
              }),
              // i18nId: 'aopf.pages.approvals.columnsActionView',
              // dm: '查看',
              active: true,
            })}
          </div>
          <Divider direction="ver" />

          {/* {renderActionItem({
            icon: 'undo',
            i18nId: 'aopf.pages.approvals.columnsActionWithdraw',
            dm: '重新发送',
            abled: record.status=='PROCESSING',
          })} */}
          {record?.status == 'PROCESSING' ? (
            <Confirm
              trigger={renderActionItem({
                icon: 'undo',
                content: $i18n.get({
                  id: 'aopf.pages.member.Invitations.columnsActionWithdraw',
                  dm: '撤退',
                }),
                // i18nId: 'aopf.pages.member.Invitations.columnsActionWithdraw',
                // dm: '撤退',
                active: record.status == 'PROCESSING',
              })}
              dialogTitle={$i18n.get({
                id: 'aopf.pages.member.Invitations.columnsActionWithdraw.messageTitle',
                dm: '撤回',
              })}
              dialogContent={$i18n.get({
                id: 'aopf.pages.member.Invitations.columnsActionWithdraw.message',
                dm: '确认撤回？',
              })}
              width={500}
              onClick={handleOk.bind(null, record)}
            />
          ) : (
            renderActionItem({
              icon: 'undo',
              content: $i18n.get({
                id: 'aopf.pages.member.Invitations.columnsActionWithdraw',
                dm: '撤退',
              }),
              // i18nId: 'aopf.pages.member.Invitations.columnsActionWithdraw',
              // dm: '撤退',
              active: record.status == 'PROCESSING',
            })
          )}
        </div>
      ),
    };
    setColumns([...getColumns(spaceId), actionRender]);
    // 查下已完成审批列表
    //  Requests.get('/rest/intercnn/approve/query',{currentPage: 1,pageSize: 10,createUid:accountId}).then((res)=>{

    // });
  }, [accountId, paginationValue, spaceId]);

  useEffect(() => {
    queryMyRequest({ createUid: accountId, ...paginationValue, sourceSpaceId: spaceId });
  }, [paginationValue, queryMyRequest, spaceId]);

  return (
    <div className="list-content">
      {/* {loading && <Spining />} */}
      <Table.StickyLock
        columns={column}
        fixedHeader
        maxBodyHeight={contentHeight - 48}
        loading={loading}
        dataSource={dataSource?.list}
        rowkey="approveId"
      />
      <div className="pagenation-container">
        <PaginationComponent
          total={dataSource?.total}
          current={paginationValue?.currentPage}
          pageSize={paginationValue?.pageSize}
          onPageChange={(current, pageSize) => {
            setPaginationValue({
              currentPage: current,
              pageSize,
            });
          }}
        />
      </div>
    </div>
  );
};
export default MyRequest;
